/**
 * opora-edge-config.js — single source for Edge platform URLs.
 * Loaded synchronously from theme.liquid before deferred tool scripts.
 */
(function (w) {
  'use strict';

  var worker = (w.OPORA_WORKER_URL || 'https://api.oporasupply.com').replace(/\/$/, '');
  var fallback = (w.OPORA_WORKER_URL_FALLBACK || 'https://opora-ai.mshabliy.workers.dev').replace(/\/$/, '');
  /* Primary auth host — custom domain (Clerk primary). Pages.dev is deploy URL only. */
  var pagesDash = 'https://opora-dashboard.pages.dev';
  var dashCustom = 'https://dashboard.oporasupply.com';
  var dash = dashCustom;
  var useWwwAccount = w.OPORA_USE_WWW_ACCOUNT !== false;
  var wwwAccount = '/pages/account';
  var wwwLibrary = '/pages/account-library';
  var wwwSettings = '/pages/account-settings';

  function withRedirect(base) {
    return base;
  }

  /** Single auth check for gates, save, export locks */
  function isAuthed() {
    try {
      if (w.OporaAccount && typeof w.OporaAccount.isSignedIn === 'function' && w.OporaAccount.isSignedIn()) {
        return true;
      }
      if (w.Clerk && w.Clerk.session) return true;
      if (w.OporaUser && w.OporaUser.isLoggedIn) return true;
    } catch (e) {}
    return false;
  }

  function accountUrl(path) {
    return useWwwAccount ? (path || wwwAccount) : dash;
  }

  /** Clerk satellite opts — primary sign-in on dashboard.oporasupply.com */
  function clerkSatelliteOpts() {
    if (w.location.hostname === 'dashboard.oporasupply.com' ||
        w.location.hostname === 'opora-dashboard.pages.dev') return {};
    return {
      isSatellite: true,
      domain: function (url) { return (url && url.host) || w.location.host; },
      signInUrl: dashCustom + '/',
      signUpUrl: dashCustom + '/?intent=sign-up'
    };
  }

  function stripClerkPathNoise(href) {
    try {
      var u = new URL(href, w.location.origin);
      var noise = /\/(factor-one|factor-two|verify|continue|sso-callback)(\/|$)/gi;
      var path = u.pathname;
      while (noise.test(path)) {
        path = path.replace(noise, '/');
        noise.lastIndex = 0;
      }
      path = path.replace(/\/+/g, '/');
      if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
      u.pathname = path;
      u.hash = '';
      u.searchParams.delete('preview_theme_id');
      return u.href;
    } catch (e) {
      return href;
    }
  }

  function cleanAuthReturnUrl(href) {
    return stripClerkPathNoise(href || w.location.href);
  }

  function stashAuthReturn() {
    try { sessionStorage.setItem('_opora_auth_return', cleanAuthReturnUrl()); } catch (e) {}
  }

  /** QA / admin: unlimited runs + internal auth header on worker calls */
  var ADMIN_EMAILS = ['mshabliy@gmail.com'];

  function enableUnlimitedMode(badgeLabel) {
    if (w.OPORA_QA_UNLIMITED) return;
    w.OPORA_QA_UNLIMITED = true;
    w.OPORA_ADMIN_UNLIMITED = badgeLabel === 'Admin';
    w.OPORA_INTERNAL_AUTH = 'opora-internal';

    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && (k.indexOf('ot_runs_') === 0 || k === 'opora_anon_first_run_at' || k === 'opora_run_ids')) {
          localStorage.removeItem(k);
        }
      }
    } catch (e) {}

    var origFetch = w.fetch.bind(w);
    if (!w.__oporaFetchPatched) {
      w.__oporaFetchPatched = true;
      w.fetch = function (url, opts) {
        opts = opts || {};
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (u.indexOf('api.oporasupply.com') !== -1 ||
            u.indexOf('opora-ai.mshabliy.workers.dev') !== -1 ||
            u.indexOf('/api/') === 0) {
          var h = opts.headers;
          if (h instanceof Headers) {
            if (!h.has('X-Opora-Auth')) h.set('X-Opora-Auth', 'opora-internal');
          } else {
            opts.headers = Object.assign({}, h || {});
            if (!opts.headers['X-Opora-Auth']) opts.headers['X-Opora-Auth'] = 'opora-internal';
          }
        }
        return origFetch(url, opts);
      };
    }

    function patchGate() {
      var g = w.OporaGate;
      if (!g || g.__qaPatched) return;
      g.__qaPatched = true;
      g.ANON_LIMIT = 999999;
      g.guardSubmit = function () { return true; };
      g.applyPostRenderGate = function () {};
      g.getToolRuns = function () { return 0; };
      g.showHardModal = function () {};
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', patchGate);
    }
    var tries = 0;
    var timer = setInterval(function () {
      patchGate();
      if ((w.OporaGate && w.OporaGate.__qaPatched) || ++tries > 80) clearInterval(timer);
    }, 100);

    function showBadge() {
      var id = badgeLabel === 'Admin' ? 'opora-admin-badge' : 'opora-qa-badge';
      if (document.getElementById(id)) return;
      var el = document.createElement('div');
      el.id = id;
      el.setAttribute('aria-label', badgeLabel + ' unlimited mode active');
      el.textContent = badgeLabel + ' unlimited';
      el.style.cssText = 'position:fixed;bottom:calc(76px + env(safe-area-inset-bottom,0px));left:12px;z-index:99999;padding:7px 11px;border-radius:8px;background:#0F7A70;color:#fff;font:600 11px/1.35 Inter,system-ui,sans-serif;letter-spacing:.04em;text-transform:uppercase;box-shadow:0 4px 14px rgba(0,0,0,.22);pointer-events:none;';
      (document.body || document.documentElement).appendChild(el);
    }
    if (document.body) showBadge();
    else document.addEventListener('DOMContentLoaded', showBadge);
  }

  /** QA / preview testing: ?opora_qa=1 persists unlimited runs in this browser */
  function initQaUnlimited() {
    var params;
    try { params = new URLSearchParams(w.location.search); } catch (e) { return; }
    if (params.get('opora_qa') === '0') {
      try { localStorage.removeItem('opora_qa_unlimited'); } catch (e) {}
      return;
    }
    if (params.get('opora_qa') === '1') {
      try { localStorage.setItem('opora_qa_unlimited', '1'); } catch (e) {}
    }
    var on = params.get('opora_qa') === '1';
    try { on = on || localStorage.getItem('opora_qa_unlimited') === '1'; } catch (e) {}
    if (!on) return;
    enableUnlimitedMode('QA');
  }

  /** Admin operators — unlimited by Clerk primary email */
  function initAdminUnlimited() {
    function clerkEmail() {
      try {
        var u = w.Clerk && w.Clerk.user;
        if (!u) return '';
        var emails = u.emailAddresses || [];
        var primary = emails.find(function (e) { return e.id === u.primaryEmailAddressId; }) || emails[0];
        return ((primary && primary.emailAddress) || '').toLowerCase();
      } catch (e) { return ''; }
    }
    function tryAdmin() {
      var email = clerkEmail();
      if (email && ADMIN_EMAILS.indexOf(email) >= 0) {
        enableUnlimitedMode('Admin');
        return true;
      }
      return false;
    }
    if (tryAdmin()) return;
    document.addEventListener('clerk:loaded', tryAdmin);
    w.addEventListener('opora:signed-in', function () { setTimeout(tryAdmin, 200); });
    var n = 0;
    var poll = setInterval(function () {
      if (tryAdmin() || ++n > 120) clearInterval(poll);
    }, 500);
  }

  initQaUnlimited();
  initAdminUnlimited();

  function safeReturnUrl(href) {
    try {
      var u = new URL(stripClerkPathNoise(href || w.location.href));
      if (u.hostname === 'www.oporasupply.com' || u.hostname === 'oporasupply.com') {
        return u.href;
      }
    } catch (e) {}
    return null;
  }

  function dashboardAuthUrl(intent, returnHref) {
    var base = dashCustom.replace(/\/$/, '');
    var params = new URLSearchParams();
    if (intent === 'sign-up' || intent === 'signup') params.set('intent', 'sign-up');
    var ret = safeReturnUrl(returnHref);
    if (!ret) {
      try { ret = safeReturnUrl(sessionStorage.getItem('_opora_auth_return')); } catch (e2) {}
    }
    if (!ret) {
      ret = safeReturnUrl('https://www.oporasupply.com/pages/bid-drafter');
    }
    if (ret) {
      params.set('opora_return', ret);
      params.set('opora_save', '1');
    }
    var qs = params.toString();
    return base + '/' + (qs ? '?' + qs : '');
  }

  w.OporaEdge = {
    WORKER_URL: worker,
    WORKER_FALLBACK: fallback,
    DASHBOARD_URL: dash,
    DASHBOARD_CUSTOM_URL: dashCustom,
    DASHBOARD_PAGES_URL: pagesDash,
    USE_WWW_ACCOUNT: useWwwAccount,
    ACCOUNT_URL: accountUrl(wwwAccount),
    LIBRARY_URL: useWwwAccount ? wwwLibrary : dash + '/?view=workspace',
    LIBRARY_FALLBACK_URL: wwwLibrary,
    SETTINGS_URL: useWwwAccount ? wwwSettings : dash + '/?view=settings',
    ANON_LIMIT: 2,
    ASK_ANON_LIMIT: 20,
    isQaUnlimited: function () { return !!w.OPORA_QA_UNLIMITED; },
    isAdminUnlimited: function () { return !!w.OPORA_ADMIN_UNLIMITED; },
    isAuthed: isAuthed,
    clerkSatelliteOpts: clerkSatelliteOpts,
    cleanAuthReturnUrl: cleanAuthReturnUrl,
    stashAuthReturn: stashAuthReturn,
    safeReturnUrl: safeReturnUrl,
    dashboardAuthUrl: dashboardAuthUrl,
    signInUrl: function () { return dash + '/'; },
    signUpUrl: function () { return dash + '/?intent=sign-up'; },
    interimSignInUrl: function () {
      return dashCustom + '/';
    },
    libraryHref: function () { return dash + '/?view=workspace&ws=library'; },
    dashboardNavUrl: function (view, ws) {
      var u = dash + '/?view=' + encodeURIComponent(view || 'workspace');
      if (ws) u += '&ws=' + encodeURIComponent(ws);
      return u;
    },
    apiUrl: function (path) {
      var p = path.charAt(0) === '/' ? path : '/' + path;
      return worker + p;
    },
    resolveApiPath: function (path) {
      if (!path) return path;
      if (path.indexOf('/api/ask-deep') === 0) return path.replace('/api/ask-deep', '/api/edge/ask-deep');
      if (path.indexOf('/api/ask') === 0) return path.replace('/api/ask', '/api/edge/ask');
      if (path.indexOf('/api/library/list') === 0) return path.replace('/api/library/list', '/api/edge/library/list');
      if (path === '/api/pipeline/list' || path.indexOf('/api/pipeline/list') === 0) {
        return path.replace('/api/pipeline/list', '/api/edge/pipeline/list');
      }
      return path;
    },
    fetchApi: function (path, opts) {
      opts = opts || {};
      var resolved = w.OporaEdge.resolveApiPath(path);
      var headers = opts.headers || {};
      if (!headers['Content-Type'] && opts.body && typeof opts.body === 'string') {
        headers['Content-Type'] = 'application/json';
      }
      if (w.OPORA_INTERNAL_AUTH && !headers['X-Opora-Auth']) {
        headers['X-Opora-Auth'] = w.OPORA_INTERNAL_AUTH;
      }
      return fetch(worker + (resolved.charAt(0) === '/' ? resolved : '/' + resolved), Object.assign({}, opts, { headers: headers }))
        .catch(function () {
          return fetch(fallback + (resolved.charAt(0) === '/' ? resolved : '/' + resolved), Object.assign({}, opts, { headers: headers }));
        });
    }
  };
}(window));
